// Footer for a paged capture list: a "load more" button while the API reports
// a next page (next_before_id), plus a visible error if a page fails to load.
interface Props {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isError: boolean;
  fetchNextPage: () => unknown;
}

export function LoadMore({ hasNextPage, isFetchingNextPage, isError, fetchNextPage }: Props) {
  return (
    <>
      {isError ? <ListError /> : null}
      {hasNextPage ? (
        <div className="load-more">
          <button disabled={isFetchingNextPage} onClick={() => fetchNextPage()}>
            {isFetchingNextPage ? "Loading…" : "Load more"}
          </button>
        </div>
      ) : null}
    </>
  );
}

function ListError() {
  return (
    <p className="edit-error" role="alert">
      Couldn’t load captures — check your connection and reload.
    </p>
  );
}
